import { inject } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export function provideFaIcons(iconDefs: IconDefinition[]): void {
  inject(FaIconLibrary).addIcons(...iconDefs);
}
